/**
 * `<scroll-lines>`: the short lines under a swipeable row (MobileHome.dc.html reviews). The row
 * (`[data-scroll-track]`) scrolls natively with scroll-snap; this only marks the line of the item in
 * view (`[data-scroll-line]`, decorative, aria-hidden). Without JS the first line stays marked.
 */

class ScrollLines extends HTMLElement {
  #abort = null;
  #frame = 0;

  connectedCallback() {
    const track = this.querySelector("[data-scroll-track]");
    if (!track) return;
    this.#abort = new AbortController();
    track.addEventListener(
      "scroll",
      () => {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#update(track));
      },
      { passive: true, signal: this.#abort.signal },
    );
    this.#update(track);
  }

  disconnectedCallback() {
    this.#abort?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #update(track) {
    const items = [...track.children];
    const lines = [...this.querySelectorAll("[data-scroll-line]")];
    if (!items.length || !lines.length) return;
    const start = track.getBoundingClientRect().left + (parseFloat(getComputedStyle(track).scrollPaddingInlineStart) || 0);
    let current = 0;
    let best = Infinity;
    items.forEach((item, index) => {
      const distance = Math.abs(item.getBoundingClientRect().left - start);
      if (distance < best) {
        best = distance;
        current = index;
      }
    });
    lines.forEach((line, index) => line.toggleAttribute("data-current", index === current));
  }
}

customElements.define("scroll-lines", ScrollLines);
